module.exports = __webpack_public_path__ + "img/soil_temp.23ebf2c3.svg";